var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { ButtonKVBase, DefaultModal } from '@/presentation/components';
import Styles from './transfer-funds-modal-styles.scss';
import TransferSelect from './components/select';
import TransferInput from './components/input';
import { trasferFundsModalState } from './components/atoms';
import { useRecoilState, useResetRecoilState } from 'recoil';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { IconSuccess1, IconWarning1 } from '@/presentation/components/icons';
import { formatStringAccountBalance } from '@/presentation/utils/money-utils';
export const mapAccountLabel = (account) => {
    var _a;
    switch ((_a = account === null || account === void 0 ? void 0 : account.accountType) === null || _a === void 0 ? void 0 : _a.description) {
        case 'Checking':
            return `Checking Account`;
        case 'Credit Card':
            return `Credit Card`;
        case 'brokerage':
        case 'Brokerage':
            return `Brokerage`;
        case 'Pocket':
            return `Savings - ${(account === null || account === void 0 ? void 0 : account.savingName) || 'General account'}`;
        default:
            return 'Unnamed Account';
    }
};
const TransferFundsModal = ({ openModal, setOpenModal, validationTransferFunds, manageVirtualTransactions, accountFromParam, accountToParam, onTransferCompleted }) => {
    var _a;
    const resetState = useResetRecoilState(trasferFundsModalState);
    const [state, setState] = useRecoilState(trasferFundsModalState);
    const [allowToPockets, setAllowToPockets] = React.useState(true);
    const [onlyToChecking, setOnlyToChecking] = React.useState(false);
    const { getAccounts, refeshAccounts, checkingAccount } = useStudentAccounts(false);
    const accounts = getAccounts();
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const validate = (field) => {
        const { accountFrom, accountTo, amount } = state;
        const formData = { accountFrom, accountTo, amount: parseFloat(amount === null || amount === void 0 ? void 0 : amount.toString()) };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validationTransferFunds.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.accountFromError || !!prev.accountToError || !!prev.amountError })));
    };
    const isFormEmpty = () => state.amount <= 0 || state.accountFrom === null || state.accountTo === null;
    useEffect(() => resetState(), [openModal]);
    useEffect(() => {
        if (state.amount)
            validate('amount');
    }, [state.amount]);
    useEffect(() => {
        var _a, _b, _c;
        if (state.accountFrom)
            validate('accountFrom');
        if (accountFromParam || accountToParam)
            return;
        if ((_a = state.accountFrom) === null || _a === void 0 ? void 0 : _a.value) {
            const accountFromTemp = accounts.find(i => { var _a, _b; return ((_a = i === null || i === void 0 ? void 0 : i.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = state.accountFrom) === null || _b === void 0 ? void 0 : _b.value); });
            if (((_b = accountFromTemp === null || accountFromTemp === void 0 ? void 0 : accountFromTemp.accountType) === null || _b === void 0 ? void 0 : _b.description) !== 'Checking') {
                setAllowToPockets(false);
                setState(prev => (Object.assign(Object.assign({}, prev), { accountTo: null })));
            }
            else {
                setAllowToPockets(true);
            }
            if (((_c = accountFromTemp === null || accountFromTemp === void 0 ? void 0 : accountFromTemp.accountType) === null || _c === void 0 ? void 0 : _c.description) === 'Pocket') {
                setOnlyToChecking(true);
                setState(prev => (Object.assign(Object.assign({}, prev), { accountTo: null })));
            }
            else {
                setOnlyToChecking(false);
            }
        }
    }, [state.accountFrom]);
    useEffect(() => {
        if (state.accountTo)
            validate('accountTo');
    }, [state.accountTo]);
    useEffect(() => {
        if (accountFromParam) {
            const accountFrom = accounts.find(i => { var _a; return ((_a = i === null || i === void 0 ? void 0 : i.id) === null || _a === void 0 ? void 0 : _a.toString()) === accountFromParam; });
            if (accountFrom) {
                setState(prev => (Object.assign(Object.assign({}, prev), { accountFrom: {
                        value: accountFrom.id.toString(),
                        label: mapAccountLabel(accountFrom)
                    } })));
            }
        }
        if (accountToParam) {
            const accountTo = accounts.find(i => { var _a; return ((_a = i === null || i === void 0 ? void 0 : i.id) === null || _a === void 0 ? void 0 : _a.toString()) === accountToParam; });
            if (accountTo) {
                setState(prev => (Object.assign(Object.assign({}, prev), { accountTo: {
                        value: accountTo.id.toString(),
                        label: mapAccountLabel(accountTo)
                    } })));
            }
        }
    }, [accountToParam, accountFromParam, accounts.length]);
    const makeTransfer = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const response = yield manageVirtualTransactions.makeTransaction({
            idAccountFrom: parseInt(state.accountFrom.value),
            idAccountTo: parseInt(state.accountTo.value),
            amount: state.amount
        });
        if (response) {
            if ((response === null || response === void 0 ? void 0 : response.message) === 'INSUFFICIENT_FUNDS') {
                setState(prev => (Object.assign(Object.assign({}, prev), { isInsufficientFunds: true, isLoading: false })));
            }
            else {
                if (response === null || response === void 0 ? void 0 : response.status) {
                    refeshAccounts();
                    setState(prev => (Object.assign(Object.assign({}, prev), { correct: true, isLoading: false })));
                    if (onTransferCompleted)
                        onTransferCompleted();
                }
                else {
                    showCustomError('Error', response === null || response === void 0 ? void 0 : response.message);
                    setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
                }
            }
        }
        else {
            showCustomError('Error', 'An error occurred while making the transfer. Please try again later.');
        }
    });
    // remove savings account from accounts list
    const fromAccountsOptions = accounts
        .filter(i => { var _a; return ((_a = i.accountType) === null || _a === void 0 ? void 0 : _a.description) !== 'Credit Card'; })
        .map(account => ({
        value: account.id.toString(),
        label: mapAccountLabel(account)
    }));
    const toAccountsOptions = accounts
        .filter(i => {
        var _a, _b;
        if (onlyToChecking) {
            return ((_b = (_a = i.accountType) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'checking';
        }
        return true;
    })
        .filter(i => {
        var _a, _b;
        if (allowToPockets) {
            return true;
        }
        return ((_b = (_a = i.accountType) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== 'pocket';
    })
        .filter(i => { var _a; return ((_a = i.accountType) === null || _a === void 0 ? void 0 : _a.description) !== 'Credit Card'; })
        .map(account => ({
        value: account.id.toString(),
        label: mapAccountLabel(account)
    }));
    return (React.createElement(DefaultModal, { height: "53.24", hUnit: "vh", width: "53.89", wUnit: "vw", open: openModal, onClose: () => setOpenModal(false), overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: { top: '35%' }, showClose: !(state.correct || state.isInsufficientFunds) },
        React.createElement("div", { className: Styles.mainWrap }, state.correct || state.isInsufficientFunds ? (React.createElement("div", { className: Styles.resultWrap },
            state.correct && (React.createElement(React.Fragment, null,
                React.createElement(IconSuccess1, null),
                React.createElement("div", { className: Styles.t1 }, "You have successfully transferred money! "),
                React.createElement("div", { className: Styles.description },
                    React.createElement("b", null, formatStringAccountBalance((_a = state === null || state === void 0 ? void 0 : state.amount) === null || _a === void 0 ? void 0 : _a.toString())),
                    " KV transfer from",
                    ' ',
                    React.createElement("b", null, mapAccountLabel(accounts.find(i => { var _a, _b; return ((_a = i === null || i === void 0 ? void 0 : i.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = state.accountFrom) === null || _b === void 0 ? void 0 : _b.value); }))),
                    " to",
                    ' ',
                    React.createElement("b", null, mapAccountLabel(accounts.find(i => { var _a, _b; return ((_a = i === null || i === void 0 ? void 0 : i.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = state.accountTo) === null || _b === void 0 ? void 0 : _b.value); }))),
                    " was successful."))),
            state.isInsufficientFunds && (React.createElement(React.Fragment, null,
                React.createElement(IconWarning1, null),
                React.createElement("div", { className: Styles.t1 }, "Oops!"),
                React.createElement("div", { className: Styles.description }, "You don't have enough money to transfer"))),
            React.createElement("div", { style: { padding: '1rem 0rem' } },
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: state.isFormInvalid || isFormEmpty(), onClick: () => setOpenModal(false) }, "OK")))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: Styles.t1 }, "Transfer Funds"),
            React.createElement("div", { className: Styles.wrapAccounts },
                React.createElement("div", null,
                    React.createElement(TransferSelect, { name: 'accountFrom', label: 'FROM ACCOUNT', placeholder: 'Select account...', required: true, options: fromAccountsOptions, isDisabled: !!accountFromParam })),
                React.createElement("div", null,
                    React.createElement(TransferSelect, { name: 'accountTo', label: 'TO ACCOUNT', placeholder: 'Select account...', required: true, options: toAccountsOptions, isDisabled: !!accountToParam }))),
            React.createElement("div", { style: { padding: '1rem 0rem', width: '25%' } },
                React.createElement(TransferInput, { name: "amount", type: "number", placeholder: "0.00", label: "AMOUNT", required: true })),
            React.createElement("div", { style: { padding: '1rem 0rem' } },
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: state.isFormInvalid || isFormEmpty(), onClick: makeTransfer, loading: state.isLoading }, "Confirm")))))));
};
const TransferFundsModalWrapper = (props) => {
    if (props.openModal) {
        return React.createElement(TransferFundsModal, Object.assign({}, props));
    }
    return null;
};
export default TransferFundsModalWrapper;
